'use client';

import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { Modal } from '@lichtblick/photon/organisms/modal/modal';
import { type FC, type PropsWithChildren, useState } from 'react';

export const HOTLINE_MODAL_TITLE = 'Wir beraten dich gerne und nehmen deine Bestellung über unsere Hotline entgegen.';

export const HotlineModal: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <BoxCTA as="button" onClick={() => setIsOpen(true)} wide>
        Zur Hotline
      </BoxCTA>
      <Modal
        footerContent={
          <TextCTA as="button" onClick={() => setIsOpen(false)}>
            Schließen
          </TextCTA>
        }
        isOpen={isOpen}
        onPointerDownOutside={() => setIsOpen(false)}
        title={HOTLINE_MODAL_TITLE}
      >
        {children}
      </Modal>
    </>
  );
};
